import { all, call, takeLatest, put } from 'redux-saga/effects'
import {
  rejectPromiseAction,
  resolvePromiseAction
} from 'redux-saga-promise-actions'

import { occupationsIds } from '../../utils/constants'

import { showAlertMessage } from '../alert/actions'
import { editUserRSPA } from '../users/actions'
import { createUser } from '../auth/services'

import * as actions from './actions'
import * as services from './services'

export function * fetchDoormenRequest ({ payload }) {
  try {
    const response = yield call(services.fetchDoormen, payload)
    yield put(actions.getDoormenSuccessful(response))
  } catch (error) {
    console.error(error)
    yield put(actions.getDoormenFailure(error))
  }
}

export function * createDoormanRequest ({ payload }) {
  try {
    const {
      id,
      school_id,
      has_school_doorman,
      has_doorman_occupation,
      ...data
    } = payload

    let response
    if (id) {
      yield put(
        editUserRSPA.request({
          userId: id,
          values: {
            ...data,
            ...(!has_doorman_occupation
              ? {
                  user_occupations_attributes: [
                    { occupation_id: occupationsIds['DOORMAN'] }
                  ]
                }
              : {}),
            ...(!has_school_doorman
              ? { school_doormen_attributes: [{ school_id }] }
              : {})
          }
        })
      )
    } else {
      yield call(createUser, {
        ...data,
        user_occupations_attributes: [
          { occupation_id: occupationsIds['DOORMAN'] }
        ],
        school_doormen_attributes: [{ school_id }]
      })
    }
    const successMessage =
      id && !has_doorman_occupation
        ? 'Ocupação adicionada com sucesso!'
        : id
          ? 'Controlador editado com sucesso!'
          : 'Controlador cadastrado com sucesso!'
    yield put(
      showAlertMessage({
        message: successMessage,
        severity: 'success'
      })
    )
    yield put(actions.createDoormanSuccessful(response))
  } catch (error) {
    console.error(error)
    yield put(
      showAlertMessage({
        message: 'Erro ao cadastrar controlador.',
        severity: 'error'
      })
    )
    yield put(actions.createDoormanFailure(error))
  }
}

export function * removeDoormanRequest (action) {
  try {
    const { payload: { school_doorman_id } } = action
    const response = yield call(services.removeDoorman, school_doorman_id)
    resolvePromiseAction(action, response)
  } catch (error) {
    rejectPromiseAction(action, error)
    console.error(error)
  }
}

export function * watchDoormen () {
  yield takeLatest(actions.getDoormen, fetchDoormenRequest)
  yield takeLatest(actions.createDoorman, createDoormanRequest)
  yield takeLatest(actions.removeDoormanRSPA.request, removeDoormanRequest)
}

export default function * doormenSaga () {
  yield all([watchDoormen()])
}
